module.exports = __webpack_public_path__ + "static/left-background-da9c9f116cab80e2a5005bc0f2ffb322.png";